<div class="button-container">
  <div class="cancel-btn" (click)="cancel.emit()">{{ cancelLabel }}</div>
  <button class="create-button" [disabled]="submitDisabled || loading" (click)="submit.emit()">
    {{ loading ? loadingLabel : submitLabel }}
  </button>
</div>
